export function exportToCsv(rows, columns, filename) {
  const SEP = ';';
  const escape = (val) => {
    const s = val == null ? '' : String(val);
    return s.includes(SEP) || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map((c) => escape(c.label)).join(SEP);
  const body = rows.map((row) => columns.map((c) => escape(c.value(row))).join(SEP)).join('\n');

  const blob = new Blob(['﻿' + header + '\n' + body], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
